import { IonRow, IonCol, IonGrid } from "@ionic/react";
import React from "react";
import { DestinationRadius, Destination } from "../../../utils/constants";
import { NewInput } from "../../../components/shared/NewUIComponents/OriginInput";
import { RadiusRange } from "../../../components/shared/NewUIComponents/RadiusRange";
import { useTranslation } from "react-i18next";
import { PickUpTimeComponent } from "../../../components/shared/pickupTimeComponent";
const DeliverypData = (props: any) => {
  const {
    destinationError,
    destination,
    destinationRadius,
    destinationCountry,
    destinationPostalCode,
    dropUpdateError,
    defaultValue,
    isDestination,
    useHandler,
    setErrorValue,
    updateLocalCurrentTime,
    dropLocalTime,
    showDate,
    isCapacitor,
    dropStartDate,
    dropEndDate,
    rangeDisable,
    handleError,
    allowAnywhere = false,
  } = props;
  const upDateLocalTime = (time: string) => {
    updateLocalCurrentTime('dropStartDate', time);
  };

  const dateChanged = (e: any) => {
    const event = {
      target: {
        name: e.target.name === 'fromDate' ? 'dropStartDate' : 'dropEndDate',
        value: e.target.value,
      },
    };
    props.handleChange(event);
  };

  const { t } = useTranslation();
  return (
    <IonGrid className="delivery-data"  data-testid="deliveryData">
      <IonRow>
        <IonCol>
          <NewInput
          data-testid="newinput"
            Error={destinationError}
            locationValue={false}
            labelValue={t('Destination')}
            InputValue={destination}
            InputName={Destination}
            handleChange={props.handleChange}
            keyboardshowHandler={props.keyboardshowHandler}
            keyboardhideHandler={props.keyboardhideHandler}
            deFaultValue={defaultValue}
            isDestination={isDestination}
            useHandler={useHandler}
            setErrorValue={setErrorValue}
            getLocalTime={upDateLocalTime}
            onFocus={props.onFocus || (() => null)}
            country={destinationCountry}
            postalCode={destinationPostalCode}
            isCapacitor={isCapacitor}
            allowAnywhere={allowAnywhere}
          />
        </IonCol>
      </IonRow>
      <IonRow>
        <IonCol data-testid="radiusRange">
          <RadiusRange
            labelName={t('Destination Radius')}
            rangeDisabled={rangeDisable}
            InputValue={destinationRadius}
            divClassName="pickRadius"
            name={DestinationRadius}
            handleChange={props.handleChange}
          />
        </IonCol>
      </IonRow>
      {showDate ? (
        <IonRow>
          <IonCol data-testid= "pickTimeComponent">
            <PickUpTimeComponent
              pickUpLocalTime={dropLocalTime}
              handleChange={dateChanged}
              fromDate={dropStartDate}
              toDate={dropEndDate}
              error={dropUpdateError}
              handleError={handleError}
              disable={rangeDisable}
              display-timezone="utc"
              errorMessage2={props.errorMessage2}
              errorMessage={props.isSearch ? (props.errorToBeShow || (dropStartDate > dropEndDate ?'dropUpdateError' : '')) : "dropdateError1"}
              label="Drop Date"
            />
          </IonCol>
        </IonRow>
      ) : null}
    </IonGrid>
  );
};
export default React.memo(DeliverypData);
